import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgNewsArrowIcon = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	"data-rtl-mirror": "true",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("mask", {
			id: "mask0_582_1237",
			style: { maskType: "alpha" },
			maskUnits: "userSpaceOnUse",
			x: 0,
			y: 0,
			width: 24,
			height: 24,
			children: /* @__PURE__ */ _jsx("rect", {
				width: 24,
				height: 24,
				fill: "#D9D9D9"
			})
		}),
		/* @__PURE__ */ _jsx("g", {
			mask: "url(#mask0_582_1237)",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M12.675 12L10.3 14.375C10.1167 14.5583 10.025 14.7875 10.025 15.0625C10.025 15.3375 10.1167 15.575 10.3 15.775C10.5 15.975 10.7375 16.075 11.0125 16.075C11.2875 16.075 11.525 15.975 11.725 15.775L14.8 12.7C15 12.5 15.1 12.2667 15.1 12C15.1 11.7333 15 11.5 14.8 11.3L11.7 8.2C11.5 8 11.2667 7.90417 11 7.9125C10.7333 7.92083 10.5 8.025 10.3 8.225C10.1167 8.425 10.0208 8.65833 10.0125 8.925C10.0042 9.19167 10.1 9.425 10.3 9.625L12.675 12ZM12 22C10.6167 22 9.31667 21.7375 8.1 21.2125C6.88333 20.6875 5.825 19.975 4.925 19.075C4.025 18.175 3.3125 17.1167 2.7875 15.9C2.2625 14.6833 2 13.3833 2 12C2 10.6167 2.2625 9.31667 2.7875 8.1C3.3125 6.88333 4.025 5.825 4.925 4.925C5.825 4.025 6.88333 3.3125 8.1 2.7875C9.31667 2.2625 10.6167 2 12 2C13.3833 2 14.6833 2.2625 15.9 2.7875C17.1167 3.3125 18.175 4.025 19.075 4.925C19.975 5.825 20.6875 6.88333 21.2125 8.1C21.7375 9.31667 22 10.6167 22 12C22 13.3833 21.7375 14.6833 21.2125 15.9C20.6875 17.1167 19.975 18.175 19.075 19.075C18.175 19.975 17.1167 20.6875 15.9 21.2125C14.6833 21.7375 13.3833 22 12 22Z",
				fill: "white"
			})
		})
	]
});
const ForwardRef = forwardRef(SvgNewsArrowIcon);
export default ForwardRef;
